<div class="container-sidebar-feedback-ideas">
  <app-state [state]="state">
    <ng-container *ngIf="!state.loading && !state.error;">
      <ng-container *ngIf="data.master.length > 0; else templateNoData;">
        <div class="data-list">
          <ng-container *ngFor="let idea of data.display; index as index;">
            <app-feedback-idea-display [idea]="idea"></app-feedback-idea-display>
          </ng-container>
        </div>

        <app-pagination-new-component [arrayData]="data.filtered" [arrayDisplay]="data.display" #pagination></app-pagination-new-component>
      </ng-container>

      <ng-template #templateNoData>
        <app-empty-state [height]="'200px'" [imageSrc]="'assets/img/empty-state/empty-state-ideas.svg'" [message]="'No ideas'"></app-empty-state>
      </ng-template>
    </ng-container>
  </app-state>
</div>